import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context("./modules", false, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((module, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath
    .replace(/^\.\/(.*)\.\w+$/, "$1")
    .replace(/-([a-z])/g, (g) => g[1].toUpperCase());
  const value = modulesFiles(modulePath);
  module[moduleName] = value.default;
  return module;
}, {});

export default new Vuex.Store({
  modules,
  strict: true,
});
